"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.looped = exports.isBetween = exports.repeat = exports.range = exports.shuffleArray = exports.inRange = exports.getFormattedTime = exports.darken = exports.getRandomInt = exports.getRandom = exports.corner = exports.center = exports.centerText = exports.lerpColor = void 0;
exports.lerpColor = function (col1, col2, percent) {
    const r1 = col1 >> 16, g1 = col1 >> 8 & 0xFF, b1 = col1 & 0xFF;
    const r2 = col2 >> 16, g2 = col2 >> 8 & 0xFF, b2 = col2 & 0xFF;
    const r = r1 + percent * (r2 - r1), g = g1 + percent * (g2 - g1), b = b1 + percent * (b2 - b1);
    return (r << 16) + (g << 8) + (b | 0);
};
function centerText(text) {
    const bounds = text.getBounds();
    text.x -= bounds.width / 2;
    text.y -= bounds.height / 2;
}
exports.centerText = centerText;
function center(x, y, w, h) {
    return [w / 2 + x, h / 2 + y];
}
exports.center = center;
function corner(cx, cy, w, h) {
    return [cx - w / 2, cy - h / 2];
}
exports.corner = corner;
/**
 * Returns a random object from an array.
 * @param arr Array to retrieve object from.
 */
function getRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
exports.getRandom = getRandom;
/**
 * Returns random integern number between min (inclusive) and max (exclusive).
 * @param min Minimum value (inclusive).
 * @param maxExclusive Maximum value (exclusive).
 */
function getRandomInt(min, maxExclusive) {
    return Math.floor(Math.random() * (maxExclusive - min) + min);
}
exports.getRandomInt = getRandomInt;
function darken(color, percent) {
    let r = Math.floor((color >> 16) * (1 - percent));
    let g = Math.floor(((color >> 8) & 0xFF) * (1 - percent));
    let b = Math.floor((color & 0xFF) * (1 - percent));
    return (r << 16) | (g << 8) | b;
}
exports.darken = darken;
function getFormattedTime(time) {
    const ms = "" + Math.floor((time % 1000) / 10);
    const secs = "" + Math.floor(time / 1000) % 60;
    const mins = "" + Math.floor(time / 60000);
    return mins.padStart(2, ' ') + ":" + secs.padStart(2, '0') + "." + ms.padStart(2, '0');
}
exports.getFormattedTime = getFormattedTime;
/**
 * Guarantees that a value will be between (0, length]. Useful for getting index
 * in bounds of an array when it can be negative or positive.
 * @param val Number to normalize.
 * @param length Length of array.
 */
function inRange(val, length) {
    while (val < 0) {
        val += length;
    }
    if (val >= length) {
        val %= length;
    }
    return val;
}
exports.inRange = inRange;
/**
 * Shuffles an array in place.
 * @param array Array to shuffle.
 */
function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}
exports.shuffleArray = shuffleArray;
/**
 * Creates an array filled numbers from start (inclusive) to end (exclusive).
 */
function range(start, endExclusive) {
    return [...Array(endExclusive - start).keys()].map(i => i + start);
}
exports.range = range;
function repeat(arr, times) {
    let ret = [];
    for (let i = 0; i < times; i++) {
        ret = ret.concat(arr);
    }
    return ret;
}
exports.repeat = repeat;
// Returns true if val is between num1 (exclusive) and num2 (inclusive).
function isBetween(num1, val, num2) {
    return num1 < val && val <= num2;
}
exports.isBetween = isBetween;
function looped(num1, repeatVal, num2) {
    let loop1 = num1 / repeatVal;
    let loop2 = num2 / repeatVal;
    let ceilLoop1 = Math.ceil(loop1);
    return loop2 >= loop1 + 1 || (loop1 < ceilLoop1 && ceilLoop1 <= loop2);
}
exports.looped = looped;
